// RMI-2026-591 (react-refresh/only-export-components): split out of
// AuthContext.jsx, which now exports only the AuthProvider component.
import { createContext, useContext } from 'react';

export const AuthContext = createContext({});

export const useAuth = () => {
  return useContext(AuthContext);
};
